import { render, staticRenderFns } from "./BarChartImagesNumber.vue?vue&type=template&id=5de85b7a&scoped=true&"
import script from "./BarChartImagesNumber.vue?vue&type=script&lang=js&"
export * from "./BarChartImagesNumber.vue?vue&type=script&lang=js&"
import style0 from "./BarChartImagesNumber.vue?vue&type=style&index=0&id=5de85b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de85b7a",
  null
  
)

export default component.exports